<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
export default {
  name: "App",
  mounted () {
    // 直接在最外层的div调用该函数即可
    changeOrientation($('#app'));
    function changeOrientation ($print) {
      var width = document.documentElement.clientWidth;
      var height = document.documentElement.clientHeight;
      if (width < height) {
        // 竖屏
        $print.width(height);
        $print.height(width);
        $print.css('top', (height - width) / 2);
        $print.css('left', 0 - (height - width) / 2);
        $print.css('transform', 'rotate(90deg)');
        $print.css('transform-origin', '50% 50%');
      }
      var evt = "onorientationchange" in window ? "orientationchange" : "resize";
      window.addEventListener(evt, function () {
        console.log(evt);
        setTimeout(function () {
          var width = document.documentElement.clientWidth;
          var height = document.documentElement.clientHeight;
          if (width > height) {
            // 横屏
            $print.width(width);
            $print.height(height);
            $print.css('top', 0);
            $print.css('left', 0);
            $print.css('transform', 'none');
            $print.css('transform-origin', '50% 50%');
          }
          else {
            // 竖屏
            $print.width(height);
            $print.height(width);
            $print.css('top', (height - width) / 2);
            $print.css('left', 0 - (height - width) / 2);
            $print.css('transform', 'rotate(90deg)');
            $print.css('transform-origin', '50% 50%');
          }

        }, 300);

      }, false);
    }
  }
};
</script>
<style lang="less">
body {
  margin: 0;
  .el-message.el-message--info {
    top: 40%;
    .el-icon-info {
      color: #7988ad;
    }
    .el-message__content {
      color: #7988ad;
    }
  }
}
#app {
  font-family: "PingFang SC", "Microsoft YaHei", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #394565;
  position: fixed;
  width: 100%;
  height: 100%;
  overflow-y: auto;
  font-size: 14px;
  background-color: #f0f0f0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue